import React, { useEffect } from 'react'
import './Gallery_frames.css'
import Breadcrumb_Comp from '../../common/common_components/breadcrumb_comp/Breadcrumb_Comp'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AllBanner, AllFrameCategory } from '../../../features/admin/common/Slice'
import { IDS } from '../../../utils/IDS'
import { encodeId } from '../../../utils/common'

const Gallery_frames = () => {
    const breadcrumbs = [
        { label: "Explore", link: "/explore", active: false },
        { label: "Journey Through Frames", link: "", active: true, },
    ];

    const frames = [
        { image: '/assets/images/gallery/gal1.png', name: 'Events', link: '/gallery-slider' },
        { image: '/assets/images/gallery/gal1.png', name: 'Spiritual Insights', link: '/gallery-slider' },
        { image: '/assets/images/gallery/gal1.png', name: 'Event Videos', link: '/gallery-slider' },
        { image: '/assets/images/gallery/gal1.png', name: 'Shibir', link: '/gallery-slider' },
        { image: '/assets/images/gallery/gal1.png', name: 'Joyful Celebrations', link: '/gallery-slider' },
        { image: '/assets/images/gallery/gal1.png', name: 'Spiritual Quotes', link: '/gallery-slider' },
    ]


    const dispatch = useDispatch();

    const all_frame_cats = useSelector((state) => state.common.all_frame_cats);

    console.log({ all_frame_cats });


    useEffect(() => {
        dispatch(AllFrameCategory());
    }, [dispatch])


    return (
        <>
            <section className='Gallery_frames_sec'>
                <div className='container'>
                    <Breadcrumb_Comp data={breadcrumbs} />

                    <div className='frames_sec'>
                        <div className='row'>
                            {all_frame_cats.map((data, index) => (
                                <div className='col-md-4 col-sm-6 mb-5'>
                                    <div className='frame_card'>
                                        <Link to={`/gallery-slider/${encodeId(data?.f_category_id)}`}>
                                            <div className='img_div'>
                                                <img className='frame_img' src={IDS.IMG_URL + data?.Frames_Category?.image} alt="frame" />
                                                {/* <img className='frame_img' src={process.env.PUBLIC_URL + '/assets/images/gallery/gal1.png'} alt="frame" /> */}
                                            </div>
                                            <div className='text_div'>
                                                <div>
                                                    <p className='name'>{data.name}</p>
                                                    <p className='name2'>{data.name}</p>
                                                </div>
                                                <div className='bdbot'></div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Gallery_frames